import { useTypedParams } from '@sorare/routing';

import { PrizePoolContenderPage } from 'pages/PrizePoolContenderPage';

import type { PageParams } from './__generated__/routeParams';

const NBAPrizePoolPage = () => {
  const { leaderboard } = useTypedParams<PageParams>();

  return <PrizePoolContenderPage leaderboard={leaderboard} />;
};

export default NBAPrizePoolPage;
